import React from "react";
import smart from "../assets/mobile.JPG";
import Header from "../components/Header"; // Assuming you have a Header component
import Footer from "../components/Footer";
import styles from "../styles/MobilePos.module.css";
import tarns from "../assets/consult.svg";
import imag from "../assets/terminal.svg";
import images from "../assets/Group 1.svg";
import secure from "../assets/customer.svg";

const MobilePos = () => {
  return (
    <div>
      <Header />
      <div>
        <div
          className={styles.container}
          style={{
            display: "flex",

            justifyContent: "space-between",
            alignItems: "flex-start",
            backgroundImage: "linear-gradient(to bottom, #e0ffe0, transparent)",
            flexWrap: "wrap", // ensures it adapts better if screen is small
          }}
        >
          {/* Left Side */}
          <div className={styles.content} style={{ maxWidth: "100%" }}>
            <h2
              style={{
                // marginTop:'50px',
                marginLeft: "30px",
                marginBottom: "0",
                fontSize: "30px",
                overflow: "hidden",
                color: "green",
                // marginTop: "40px",
                lineHeight: 1.2,
              }}
            >
              ARIF M-POS
            </h2>
            <h3
              className={styles.title}
              style={{
                fontSize: "28px",
                overflow: "hidden",
                color: "black",
                marginTop: "0",
                lineHeight: 1.2,
                textAlign: "left",
              }}
            >
              Experience the Smart, Sleek, and
              <br />
              Simple Payment Solution
            </h3>
          </div>

          {/* Right Side */}
          <div
            className={styles.contents}
            style={{ maxWidth: "100%", textAlign: "left" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "1em",
              }}
            >
              <span
                className={styles.icons}
                style={{ marginRight: "10px", marginTop: "30px" }}
              >
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8333 5.6665C16.1023 6.91908 17.0807 7.89753 18.3333 8.1665C17.0807 8.43548 16.1023 9.41393 15.8333 10.6665C15.5643 9.41393 14.5859 8.43548 13.3333 8.1665C14.5859 7.89753 15.5643 6.91908 15.8333 5.6665ZM7.56 5.83317C8.31958 9.37044 11.0827 12.1336 14.62 12.8932C11.0827 13.6528 8.31958 16.4159 7.56 19.9532C6.80042 16.4159 4.03726 13.6528 0.5 12.8932C4.03726 12.1336 6.80042 9.37044 7.56 5.83317ZM18.3333 18.9998C16.6632 18.6412 15.3586 17.3366 15 15.6665C14.6413 17.3366 13.3367 18.6412 11.6666 18.9998C13.3367 19.3585 14.6413 20.6631 15 22.3332C15.3586 20.6631 16.6632 19.3585 18.3333 18.9998Z"
                    fill="#3A7326"
                  />
                </svg>
              </span>
              <p
                style={{ fontSize: "16px", color: "black", marginTop: "25px", marginRight:"30px" }}
              >
                <span className={styles.new}>✓</span>
                Engineered with utmost flexibility, our solution
                <br />
                seamlessly accepts all payment methods, including
                <br />
                NFC/Contactless.
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "1em",
              }}
            >
              <span className={styles.icons} style={{ marginRight: "10px" }}>
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8333 5.6665C16.1023 6.91908 17.0807 7.89753 18.3333 8.1665C17.0807 8.43548 16.1023 9.41393 15.8333 10.6665C15.5643 9.41393 14.5859 8.43548 13.3333 8.1665C14.5859 7.89753 15.5643 6.91908 15.8333 5.6665ZM7.56 5.83317C8.31958 9.37044 11.0827 12.1336 14.62 12.8932C11.0827 13.6528 8.31958 16.4159 7.56 19.9532C6.80042 16.4159 4.03726 13.6528 0.5 12.8932C4.03726 12.1336 6.80042 9.37044 7.56 5.83317ZM18.3333 18.9998C16.6632 18.6412 15.3586 17.3366 15 15.6665C14.6413 17.3366 13.3367 18.6412 11.6666 18.9998C13.3367 19.3585 14.6413 20.6631 15 22.3332C15.3586 20.6631 16.6632 19.3585 18.3333 18.9998Z"
                    fill="#3A7326"
                  />
                </svg>
              </span>
              <p style={{ fontSize: "16px", color: "black", margin: 0 }}>
                <span className={styles.new}>✓</span>
                Our payment solution is optiimized for all existing
                <br />
                infrastructures, thanks to its versatile connectivity
                <br />
                options.
              </p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "1em",
              }}
            >
              <span className={styles.icons} style={{ marginRight: "10px" }}>
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8333 5.6665C16.1023 6.91908 17.0807 7.89753 18.3333 8.1665C17.0807 8.43548 16.1023 9.41393 15.8333 10.6665C15.5643 9.41393 14.5859 8.43548 13.3333 8.1665C14.5859 7.89753 15.5643 6.91908 15.8333 5.6665ZM7.56 5.83317C8.31958 9.37044 11.0827 12.1336 14.62 12.8932C11.0827 13.6528 8.31958 16.4159 7.56 19.9532C6.80042 16.4159 4.03726 13.6528 0.5 12.8932C4.03726 12.1336 6.80042 9.37044 7.56 5.83317ZM18.3333 18.9998C16.6632 18.6412 15.3586 17.3366 15 15.6665C14.6413 17.3366 13.3367 18.6412 11.6666 18.9998C13.3367 19.3585 14.6413 20.6631 15 22.3332C15.3586 20.6631 16.6632 19.3585 18.3333 18.9998Z"
                    fill="#3A7326"
                  />
                </svg>
              </span>
              <p style={{ fontSize: "16px", color: "black", margin: 0 }}>
                <span className={styles.new}>✓</span> Take payment acceptance
                wherever you go:the perfect
                <br />
                payment terminal for busy mobile merchants
                <br />
              </p>
            </div>

            <div
              className={styles.downButton}
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "flex-end",
              }}
            >
              {/* <button
                className={styles.butt}
                style={{
                  color: "white",
                  border: "none",
                  fontSize: "1em",

                  backgroundColor: "var(--primary-green)",
                  padding: "10px 25px",
                  borderRadius: "15px",
                }}
              >
                Find Reseller →
              </button> */}
              <button
                className={styles.butt}
                style={{
                  color: "white",
                  backgroundColor: "var(--primary-green)",
                  marginRight: "200px",
                  border: "1px solid lightgreen",
                  padding: "15px 40px",
                  borderRadius: "15px",
                }}
              >
                Contact Sales
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div
              className={styles.topImage}
              style={{
                width: "100%",
                height: "450px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={smart}
                alt="mobile pos"
                style={{
                  display: "block",
                  width: "100%",
                  height: "450px",
                  objectFit: "cover",
                  borderRadius: "35px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.mobile}>
      <section className={styles.dev}>
        <div className={styles.viewText} style={{ flex: 1 }}>
          <p style={{ fontSize: "25px", marginBottom:"0" }} className={styles.sectionLabel}>
            OUR MOBILE POS
          </p>
          <h3
            style={{ fontSize: "30px", color: "black", marginBottom: "0px", marginTop:'20px' }}
          >
            Key Features
          </h3>
          <p
            style={{ fontSize: "18px", color: "black", marginBottom: "40px" }}
            className={styles.paragraph}
          >
            Introducing Arif Mobile POS, the payment acceptance solution for
            every mobile business for
            <br />
            maximized network availability
          </p>
          {/* <p
            style={{ fontSize: "1.2rem", color: "black", marginBottom: "20px" }}
          >
            <span
              style={{
                gap: "20px",
                padding: "5px",
                color: "green",
                fontSize: "1.2em",
                marginRight: "5px",
                marginBottom: "20px",
              }}
            >
              ✦
            </span>{" "}
            Maximized network availability
            <br />
            <br />
            <span
              style={{
                gap: "5px",
                padding: "5px",
                color: "green",
                fontSize: "1.2em",
                marginRight: "5px",
              }}
            >
              ✦
            </span>{" "}
            Easily integrate with rich customer interactions
            <br />
            <br />
            <span
              style={{
                gap: "5px",
                padding: "5px",
                color: "green",
                fontSize: "1.2em",
                marginRight: "5px",
              }}
            >
              ✦
            </span>{" "}
            Easy fast self-checkout by pairing with ArifPOS <br />
          </p> */}
        </div>
      </section>
      
        <section className={styles.domesticPaymentsSection}>
          <div className={styles.paymentBox}>
            <div className={styles.leftContent}>
              {/* <img src={tarns} style={{ marginBottom: "0", marginTop: 0 }} /> */}
              <h4
                style={{
                  fontSize: "20px",
                  color: "green",
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
             Portable & Lightweight Design
              </h4>
              <p
                style={{
                  fontSize: "16px",
                  color: "black",
                  marginBottom: "30px",
                }}
              >
Compact and easy to carry ideal for mobility in stores, deliveries, pop-ups, and field sales.
              </p>

              {/* <img
                src={secure}
                style={{ marginBottom: "5px", marginTop: "10px" }}
              /> */}
              <h4
                style={{
                  fontSize: "20px",
                  color: "green",
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
                Bluetooth Connectivity
              </h4>
              <p
                style={{
                  fontSize: "16px",
                  color: "black",
                  marginBottom: "10px",
                }}
              >
Connects via Bluetooth to your main POS app or device for processing transactions securely and wirelessly.
              </p>

              
              {/* <img
                src={secure}
                style={{ marginBottom: "5px", marginTop: "10px" }}
              /> */}
              <h4
                style={{
                  fontSize: "20px",
                  color: "green",
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
             Long Battery Life
              </h4>
              <p
                style={{
                  fontSize: "16px",
                  color: "black",
                  marginBottom: "10px",
                }}
              >
Designed for all-day use with a rechargeable battery no need for constant charging during operations.
              </p>
            </div>

            <div className={styles.rightContent}>
              {/* <img
                src={imag}
                style={{ marginBottom: 0, marginRight: "330px" }}
              /> */}
              <h4
                style={{
                  fontSize: "20px",
                  color: "green",
                  marginBottom: "20px",
                  // marginRight: "180px",
                  marginTop: "10px",
                }}
              >
                Digital Receipt Support
              </h4>
              <p
                style={{
                  fontSize: "16px",
                  color: "black",
                  marginBottom: "30px",
                }}
              >
             Allows businesses to send receipts via SMS or email, providing a clean, paperless experience for customers.
              </p>

              {/* <img
                src={images}
                style={{
                  marginBottom: "0",
                  marginRight: "330px",
                  marginTop: "10px",
                }}
              /> */}
              <h4
                style={{
                  fontSize: "20px",
                  color: "green",
                  marginBottom: "20px",
                  // marginRight: "200px",
                  marginTop: "10px",
                }}
              >
               Basic Reporting Access
              </h4>
              <p
                style={{
                  fontSize: "16px",
                  color: "black",
                  marginBottom: "10px",
                }}
              >
Syncs with your main POS system to update sales, transaction logs, and settlement summaries in real-time.
              </p>

                   {/* <img
                src={images}
                style={{
                  marginBottom: "0",
                  marginRight: "330px",
                  marginTop: "10px",
                }}
              /> */}
              <h4
                style={{
                  fontSize: "20px",
                  color: "green",
                  marginBottom: "20px",
                  // marginRight: "200px",
                  marginTop: "10px",
                }}
              >
              Secure & PCI-Compliant
              </h4>
              <p
                style={{
                  fontSize: "16px",
                  color: "black",
                  marginBottom: "10px",
                }}
              >
Encrypted chip card processing, device-level PIN entry, and secure connection protocols for peace of mind.
              </p>
            </div>
          </div>
        </section>
      </div>

      <div
        className={styles.bottom}
        style={{
          backgroundColor: "#8bc34a",
          color: "#fff",
          // padding: "20px 20px",
          borderRadius: "35px",
          marginBottom: "40px",
          marginTop: "30px",
          marginLeft: "20px",
        }}
      >
        <div
          style={{
            maxWidth: "1300px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className={styles.call}
            style={{  marginBottom: "30px", width: "100%" }}
          >
            <h2
              style={{
                fontSize: "32px",
                fontWeight: "bold",
                marginBottom: "15px",
                color: "white",
              }}
            >
              Contact Us
            </h2>
            <p
              className={styles.Callus}
              style={{ fontSize: "1em", marginLeft: "0" }}
            >
              <span className={styles.icon}>✦</span> Call us for more
              information we{" "}
              <span className={styles.break}>
                <br />
              </span>{" "}
              are happy to hear from you.
              <br />
            </p>

            <button
              className={styles.contactButton}
              style={{
                backgroundColor: "#fff",
                color: "green",
                border: "none",
                padding: "15px 15px",
                borderRadius: "5px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                marginLeft: "20px",
                width: "25%",
              }}
              onClick={() => (window.location.href = "tel:9395")}
            >
              Call Us Now
            </button>
          </div>
          <div
            className={styles.but}
            style={{
              flex: "1 1 100px",
              marginBottom: "30px",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <button
              style={{
                backgroundColor: "green",
                color: "white",
                border: "none",
                padding: "30px 65px",
                borderRadius: "15px",
                fontSize: "3.4em",
                fontWeight: "bold",
                cursor: "pointer",
                width: "100%",
              }}
            >
              9395
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MobilePos;
